export const CountryList = [
  { country_code: 'US', country_name: 'USA' },
  { country_code: 'AD', country_name: 'Andorra' },
  { country_code: 'AE', country_name: 'United Arab Emirates' },
  { country_code: 'AG', country_name: 'Antigua and Barbuda' },
  { country_code: 'AI', country_name: 'Anguilla' },
  { country_code: 'AL', country_name: 'Albania' },
  { country_code: 'AN', country_name: 'Dutch Antilles' },
  { country_code: 'AO', country_name: 'Angola' },
  { country_code: 'AQ', country_name: 'Antarctica' },
  { country_code: 'AR', country_name: 'Argentina' },
  { country_code: 'AS', country_name: 'American Samoa' },
  { country_code: 'AT', country_name: 'Austria' },
  { country_code: 'AU', country_name: 'Australia' },
  { country_code: 'AW', country_name: 'Aruba' },
  { country_code: 'BA', country_name: 'Bosnia and Herzegovina' },
  { country_code: 'BB', country_name: 'Barbados' },
  { country_code: 'BD', country_name: 'Bangladesh' },
  { country_code: 'BE', country_name: 'Belgium' },
  { country_code: 'BF', country_name: 'Burkina Faso' },
  { country_code: 'BG', country_name: 'Bulgaria' },
  { country_code: 'BH', country_name: 'Bahrain' },
  { country_code: 'BI', country_name: 'Burundi' },
  { country_code: 'BJ', country_name: 'Benin' },
  { country_code: 'BL', country_name: 'St. Barthélemy' },
  { country_code: 'BM', country_name: 'Bermuda' },
  { country_code: 'BN', country_name: 'Brunei' },
  { country_code: 'BO', country_name: 'Bolivia' },
  { country_code: 'BQ', country_name: 'Bonaire, Saba' },
  { country_code: 'BR', country_name: 'Brazil' },
  { country_code: 'BS', country_name: 'Bahamas' },
  { country_code: 'BT', country_name: 'Bhutan' },
  { country_code: 'BV', country_name: 'Bouvet Islands' },
  { country_code: 'BW', country_name: 'Botswana' },
  { country_code: 'BY', country_name: 'Belarus' },
  { country_code: 'BZ', country_name: 'Belize' },
  { country_code: 'CA', country_name: 'Canada' },
  { country_code: 'CC', country_name: 'Cocos Islands' },
  { country_code: 'CD', country_name: 'Congo (Kinshasa)' },
  { country_code: 'CF', country_name: 'Central African Republic' },
  { country_code: 'CG', country_name: 'Congo (Brazzaville)' },
  { country_code: 'CH', country_name: 'Switzerland' },
  { country_code: 'CI', country_name: 'Ivory Coast' },
  { country_code: 'CK', country_name: 'Cook Islands' },
  { country_code: 'CL', country_name: 'Chile' },
  { country_code: 'CM', country_name: 'Cameroon' },
  { country_code: 'CN', country_name: 'China' },
  { country_code: 'CO', country_name: 'Colombia' },
  { country_code: 'CR', country_name: 'Costa Rica' },
  { country_code: 'CS', country_name: 'Serbia and Montenegro' },
  { country_code: 'CV', country_name: 'Cape Verde' },
  { country_code: 'CW', country_name: 'Curacao' },
  { country_code: 'CX', country_name: 'Christmas Island' },
  { country_code: 'CY', country_name: 'Cyprus' },
  { country_code: 'CZ', country_name: 'Czech Republic' },
  { country_code: 'DE', country_name: 'Germany' },
  { country_code: 'DJ', country_name: 'Djibouti' },
  { country_code: 'DK', country_name: 'Denmark' },
  { country_code: 'DM', country_name: 'Dominica' },
  { country_code: 'DO', country_name: 'Dominican Republic' },
  { country_code: 'DZ', country_name: 'Algeria' },
  { country_code: 'EA', country_name: 'Ceuta and Melilla' },
  { country_code: 'EC', country_name: 'Ecuador' },
  { country_code: 'EE', country_name: 'Estonia' },
  { country_code: 'EG', country_name: 'Egypt' },
  { country_code: 'EH', country_name: 'Western Sahara' },
  { country_code: 'ER', country_name: 'Eritrea' },
  { country_code: 'ES', country_name: 'Spain' },
  { country_code: 'ET', country_name: 'Ethiopia' },
  { country_code: 'EU', country_name: 'European Union' },
  { country_code: 'FI', country_name: 'Finland' },
  { country_code: 'FJ', country_name: 'Fiji' },
  { country_code: 'FK', country_name: 'Falkland Islands' },
  { country_code: 'FM', country_name: 'Micronesia' },
  { country_code: 'FO', country_name: 'Faroe Islands' },
  { country_code: 'FR', country_name: 'France' },
  { country_code: 'GA', country_name: 'Gabon' },
  { country_code: 'GB', country_name: 'United Kingdom' },
  { country_code: 'GD', country_name: 'Grenada' },
  { country_code: 'GE', country_name: 'Georgia' },
  { country_code: 'GF', country_name: 'French Guyana' },
  { country_code: 'GG', country_name: 'Guernsey' },
  { country_code: 'GH', country_name: 'Ghana' },
  { country_code: 'GI', country_name: 'Gibraltar' },
  { country_code: 'GL', country_name: 'Greenland' },
  { country_code: 'GM', country_name: 'Gambia' },
  { country_code: 'GN', country_name: 'Guinea' },
  { country_code: 'GP', country_name: 'Guadeloupe' },
  { country_code: 'GQ', country_name: 'Equatorial Guinea' },
  { country_code: 'GR', country_name: 'Greece' },
  { country_code: 'GS', country_name: 'South Georgia' },
  { country_code: 'GT', country_name: 'Guatemala' },
  { country_code: 'GU', country_name: 'Guam' },
  { country_code: 'GW', country_name: 'Guinea-Bissau' },
  { country_code: 'GY', country_name: 'Guyana' },
  { country_code: 'HK', country_name: 'Hong Kong' },
  { country_code: 'HM', country_name: 'Heard/McDonald Islands' },
  { country_code: 'HN', country_name: 'Honduras' },
  { country_code: 'HR', country_name: 'Croatia' },
  { country_code: 'HT', country_name: 'Haiti' },
  { country_code: 'HU', country_name: 'Hungary' },
  { country_code: 'IC', country_name: 'Canary Islands' },
  { country_code: 'ID', country_name: 'Indonesia' },
  { country_code: 'IE', country_name: 'Ireland' },
  { country_code: 'IL', country_name: 'Israel' },
  { country_code: 'IN', country_name: 'India' },
  { country_code: 'IO', country_name: 'British Indian Ocean Territory' },
  { country_code: 'IS', country_name: 'Iceland' },
  { country_code: 'IT', country_name: 'Italy' },
  { country_code: 'JE', country_name: 'Jersey' },
  { country_code: 'JM', country_name: 'Jamaica' },
  { country_code: 'JO', country_name: 'Jordan' },
  { country_code: 'JP', country_name: 'Japan' },
  { country_code: 'KE', country_name: 'Kenya' },
  { country_code: 'KG', country_name: 'Kyrgyzstan' },
  { country_code: 'KH', country_name: 'Cambodia' },
  { country_code: 'KI', country_name: 'Kiribati' },
  { country_code: 'KM', country_name: 'Comoros' },
  { country_code: 'KN', country_name: 'St. Kitts and Nevis' },
  { country_code: 'KR', country_name: 'South Korea' },
  { country_code: 'KW', country_name: 'Kuwait' },
  { country_code: 'KY', country_name: 'Cayman Islands' },
  { country_code: 'KZ', country_name: 'Kazakhstan' },
  { country_code: 'LA', country_name: 'Laos' },
  { country_code: 'LB', country_name: 'Lebanon' },
  { country_code: 'LC', country_name: 'St. Lucia' },
  { country_code: 'LI', country_name: 'Liechtenstein' },
  { country_code: 'LK', country_name: 'Sri Lanka' },
  { country_code: 'LR', country_name: 'Liberia' },
  { country_code: 'LS', country_name: 'Lesotho' },
  { country_code: 'LT', country_name: 'Lithuania' },
  { country_code: 'LU', country_name: 'Luxembourg' },
  { country_code: 'LV', country_name: 'Latvia' },
  { country_code: 'MA', country_name: 'Morocco' },
  { country_code: 'MC', country_name: 'Monaco' },
  { country_code: 'MD', country_name: 'Moldova' },
  { country_code: 'ME', country_name: 'Montenegro' },
  { country_code: 'MF', country_name: 'St. Martin' },
  { country_code: 'MG', country_name: 'Madagascar' },
  { country_code: 'MH', country_name: 'Marshall Islands' },
  { country_code: 'MK', country_name: 'Macedonia' },
  { country_code: 'ML', country_name: 'Mali' },
  { country_code: 'MM', country_name: 'Myanmar' },
  { country_code: 'MN', country_name: 'Mongolia' },
  { country_code: 'MO', country_name: 'Macau' },
  { country_code: 'MP', country_name: 'Northern Mariana Islands' },
  { country_code: 'MQ', country_name: 'Martinique' },
  { country_code: 'MR', country_name: 'Mauritania' },
  { country_code: 'MS', country_name: 'Montserrat' },
  { country_code: 'MT', country_name: 'Malta' },
  { country_code: 'MU', country_name: 'Mauritius' },
  { country_code: 'MV', country_name: 'Maldives' },
  { country_code: 'MW', country_name: 'Malawi' },
  { country_code: 'MX', country_name: 'Mexico' },
  { country_code: 'MY', country_name: 'Malaysia' },
  { country_code: 'MZ', country_name: 'Mozambique' },
  { country_code: 'NA', country_name: 'Namibia' },
  { country_code: 'NC', country_name: 'New Caledonia' },
  { country_code: 'NE', country_name: 'Niger' },
  { country_code: 'NF', country_name: 'Norfolk Islands' },
  { country_code: 'NG', country_name: 'Nigeria' },
  { country_code: 'NI', country_name: 'Nicaragua' },
  { country_code: 'NL', country_name: 'Netherlands' },
  { country_code: 'NO', country_name: 'Norway' },
  { country_code: 'NP', country_name: 'Nepal' },
  { country_code: 'NR', country_name: 'Nauru' },
  { country_code: 'NT', country_name: 'NATO' },
  { country_code: 'NU', country_name: 'Niue Islands' },
  { country_code: 'NZ', country_name: 'New Zealand' },
  { country_code: 'OM', country_name: 'Oman' },
  { country_code: 'OR', country_name: 'Orange' },
  { country_code: 'PA', country_name: 'Panama' },
  { country_code: 'PE', country_name: 'Peru' },
  { country_code: 'PF', country_name: 'French Polynesia' },
  { country_code: 'PG', country_name: 'Papua New Guinea' },
  { country_code: 'PH', country_name: 'Philippines' },
  { country_code: 'PK', country_name: 'Pakistan' },
  { country_code: 'PL', country_name: 'Poland' },
  { country_code: 'PM', country_name: 'St. Pierre and Miquelon' },
  { country_code: 'PN', country_name: 'Pitcairn Islands' },
  { country_code: 'PR', country_name: 'Puerto Rico' },
  { country_code: 'PS', country_name: 'Palestine' },
  { country_code: 'PT', country_name: 'Portugal' },
  { country_code: 'PW', country_name: 'Palau' },
  { country_code: 'PY', country_name: 'Paraguay' },
  { country_code: 'QA', country_name: 'Qatar' },
  { country_code: 'RE', country_name: 'Reunion' },
  { country_code: 'RO', country_name: 'Romania' },
  { country_code: 'RS', country_name: 'Serbia' },
  { country_code: 'RW', country_name: 'Rwanda' },
  { country_code: 'SA', country_name: 'Saudi Arabia' },
  { country_code: 'SB', country_name: 'Solomon Islands' },
  { country_code: 'SC', country_name: 'Seychelles' },
  { country_code: 'SE', country_name: 'Sweden' },
  { country_code: 'SG', country_name: 'Singapore' },
  { country_code: 'SH', country_name: 'St. Helena' },
  { country_code: 'SI', country_name: 'Slovenia' },
  { country_code: 'SJ', country_name: 'Svalbard' },
  { country_code: 'SK', country_name: 'Slovakia' },
  { country_code: 'SL', country_name: 'Sierra Leone' },
  { country_code: 'SM', country_name: 'San Marino' },
  { country_code: 'SN', country_name: 'Senegal' },
  { country_code: 'SO', country_name: 'Somalia' },
  { country_code: 'SR', country_name: 'Suriname' },
  { country_code: 'ST', country_name: 'Sao Tome and Principe' },
  { country_code: 'STL', country_name: 'Stateless' },
  { country_code: 'SV', country_name: 'El Salvador' },
  { country_code: 'SX', country_name: 'Sint Maarten' },
  { country_code: 'SZ', country_name: 'Swaziland' },
  { country_code: 'TC', country_name: 'Turks and Caicos' },
  { country_code: 'TD', country_name: 'Chad' },
  { country_code: 'TF', country_name: 'French Southern Territories' },
  { country_code: 'TG', country_name: 'Togo' },
  { country_code: 'TH', country_name: 'Thailand' },
  { country_code: 'TJ', country_name: 'Tajikistan' },
  { country_code: 'TK', country_name: 'Tokelau Islands' },
  { country_code: 'TL', country_name: 'East Timor' },
  { country_code: 'TM', country_name: 'Turkmenistan' },
  { country_code: 'TN', country_name: 'Tunisia' },
  { country_code: 'TO', country_name: 'Tonga' },
  { country_code: 'TR', country_name: 'Turkey' },
  { country_code: 'TT', country_name: 'Trinidad and Tobago' },
  { country_code: 'TV', country_name: 'Tuvalu' },
  { country_code: 'TW', country_name: 'Taiwan' },
  { country_code: 'TZ', country_name: 'Tanzania' },
  { country_code: 'UG', country_name: 'Uganda' },
  { country_code: 'UM', country_name: 'Minor Outlying Islands' },
  { country_code: 'UN', country_name: 'United Nations' },
  { country_code: 'UY', country_name: 'Uruguay' },
  { country_code: 'UZ', country_name: 'Uzbekistan' },
  { country_code: 'VA', country_name: 'Vatican City' },
  { country_code: 'VC', country_name: 'St. Vincent' },
  { country_code: 'VG', country_name: 'British Virgin Islands' },
  { country_code: 'VI', country_name: 'American Virgin Islands' },
  { country_code: 'VN', country_name: 'Vietnam' },
  { country_code: 'VU', country_name: 'Vanuatu' },
  { country_code: 'WF', country_name: 'Wallis and Futuna' },
  { country_code: 'WS', country_name: 'Western Samoa' },
  { country_code: 'YE', country_name: 'Yemen' },
  { country_code: 'YT', country_name: 'Mayotte' },
  { country_code: 'ZA', country_name: 'South Africa' },
  { country_code: 'ZM', country_name: 'Zambia' },
  { country_code: 'ZW', country_name: 'Zimbabwe' }
];

export const StateList = [
  { state_name: 'ALABAMA', state_code: 'AL', dropdown_label: 'AL - ALABAMA' },
  { state_name: 'ALASKA', state_code: 'AK', dropdown_label: 'AK - ALASKA' },
  { state_name: 'ARIZONA', state_code: 'AZ', dropdown_label: 'AZ - ARIZONA' },
  { state_name: 'ARKANSAS', state_code: 'AR', dropdown_label: 'AR - ARKANSAS' },
  { state_name: 'CALIFORNIA', state_code: 'CA', dropdown_label: 'CA - CALIFORNIA' },
  { state_name: 'COLORADO', state_code: 'CO', dropdown_label: 'CO - COLORADO' },
  { state_name: 'CONNECTICUT', state_code: 'CT', dropdown_label: 'CT - CONNECTICUT' },
  { state_name: 'DELAWARE', state_code: 'DE', dropdown_label: 'DE - DELAWARE' },
  { state_name: 'DISTRICT OF COLUMBIA', state_code: 'DC', dropdown_label: 'DC - DISTRICT OF COLUMBIA' },
  { state_name: 'FLORIDA', state_code: 'FL', dropdown_label: 'FL - FLORIDA' },
  { state_name: 'GEORGIA', state_code: 'GA', dropdown_label: 'GA - GEORGIA' },
  { state_name: 'HAWAII', state_code: 'HI', dropdown_label: 'HI - HAWAII' },
  { state_name: 'IDAHO', state_code: 'ID', dropdown_label: 'ID - IDAHO' },
  { state_name: 'ILLINOIS', state_code: 'IL', dropdown_label: 'IL - ILLINOIS' },
  { state_name: 'INDIANA', state_code: 'IN', dropdown_label: 'IN - INDIANA' },
  { state_name: 'IOWA', state_code: 'IA', dropdown_label: 'IA - IOWA' },
  { state_name: 'KANSAS', state_code: 'KS', dropdown_label: 'KS - KANSAS' },
  { state_name: 'KENTUCKY', state_code: 'KY', dropdown_label: 'KY - KENTUCKY' },
  { state_name: 'LOUISIANA', state_code: 'LA', dropdown_label: 'LA - LOUISIANA' },
  { state_name: 'MAINE', state_code: 'ME', dropdown_label: 'ME - MAINE' },
  { state_name: 'MARYLAND', state_code: 'MD', dropdown_label: 'MD - MARYLAND' },
  { state_name: 'MASSACHUSETTS', state_code: 'MA', dropdown_label: 'MA - MASSACHUSETTS' },
  { state_name: 'MICHIGAN', state_code: 'MI', dropdown_label: 'MI - MICHIGAN' },
  { state_name: 'MINNESOTA', state_code: 'MN', dropdown_label: 'MN - MINNESOTA' },
  { state_name: 'MISSISSIPPI', state_code: 'MS', dropdown_label: 'MS - MISSISSIPPI' },
  { state_name: 'MISSOURI', state_code: 'MO', dropdown_label: 'MO - MISSOURI' },
  { state_name: 'MONTANA', state_code: 'MT', dropdown_label: 'MT - MONTANA' },
  { state_name: 'NEBRASKA', state_code: 'NE', dropdown_label: 'NE - NEBRASKA' },
  { state_name: 'NEVADA', state_code: 'NV', dropdown_label: 'NV - NEVADA' },
  { state_name: 'NEW HAMPSHIRE', state_code: 'NH', dropdown_label: 'NH - NEW HAMPSHIRE' },
  { state_name: 'NEW JERSEY', state_code: 'NJ', dropdown_label: 'NJ - NEW JERSEY' },
  { state_name: 'NEW MEXICO', state_code: 'NM', dropdown_label: 'NM - NEW MEXICO' },
  { state_name: 'NEW YORK', state_code: 'NY', dropdown_label: 'NY - NEW YORK' },
  { state_name: 'NORTH CAROLINA', state_code: 'NC', dropdown_label: 'NC - NORTH CAROLINA' },
  { state_name: 'NORTH DAKOTA', state_code: 'ND', dropdown_label: 'ND - NORTH DAKOTA' },
  { state_name: 'OHIO', state_code: 'OH', dropdown_label: 'OH - OHIO' },
  { state_name: 'OKLAHOMA', state_code: 'OK', dropdown_label: 'OK - OKLAHOMA' },
  { state_name: 'OREGON', state_code: 'OR', dropdown_label: 'OR - OREGON' },
  { state_name: 'PENNSYLVANIA', state_code: 'PA', dropdown_label: 'PA - PENNSYLVANIA' },
  { state_name: 'PUERTO RICO', state_code: 'PR', dropdown_label: 'PR - PUERTO RICO' },
  { state_name: 'RHODE ISLAND', state_code: 'RI', dropdown_label: 'RI - RHODE ISLAND' },
  { state_name: 'SOUTH CAROLINA', state_code: 'SC', dropdown_label: 'SC - SOUTH CAROLINA' },
  { state_name: 'SOUTH DAKOTA', state_code: 'SD', dropdown_label: 'SD - SOUTH DAKOTA' },
  { state_name: 'TENNESSEE', state_code: 'TN', dropdown_label: 'TN - TENNESSEE' },
  { state_name: 'TEXAS', state_code: 'TX', dropdown_label: 'TX - TEXAS' },
  { state_name: 'UTAH', state_code: 'UT', dropdown_label: 'UT - UTAH' },
  { state_name: 'VERMONT', state_code: 'VT', dropdown_label: 'VT - VERMONT' },
  { state_name: 'VIRGIN ISLANDS', state_code: 'VI', dropdown_label: 'VI - VIRGIN ISLANDS' },
  { state_name: 'VIRGINIA', state_code: 'VA', dropdown_label: 'VA - VIRGINIA' },
  { state_name: 'WASHINGTON', state_code: 'WA', dropdown_label: 'WA - WASHINGTON' },
  { state_name: 'WEST VIRGINIA', state_code: 'WV', dropdown_label: 'WV - WEST VIRGINIA' },
  { state_name: 'WISCONSIN', state_code: 'WI', dropdown_label: 'WI - WISCONSIN' },
  { state_name: 'WYOMING', state_code: 'WY', dropdown_label: 'WY - WYOMING' }
];
